import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';

import { IMaskInput } from 'react-imask';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { makeStyles } from '@mui/styles';
import EditIcon from '@mui/icons-material/Edit';
import {
  IconButton, 
  Link, 
  Checkbox,
  Button,
  Box,
  Divider,
  Grid,
  Typography
} from '@mui/material'

import { createClaimAction  } from 'redux/actions/getFormActions';
import ConfirmDialog from 'components/ConfirmDialog';

const useStyles = makeStyles((theme) => ({
    select: {
        '& .MuiSvgIcon-root': {
            color: theme.palette.primary.main
        },
        '&:hover': {
            backgroundColor: '#e4dfdf6b'
        }
    },
    icon: {
        fill: theme.palette.primary,
    },
}));

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(#00) 000-0000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const Form7 = (props) => {
    const {actions, formData, handleNext, handleBack, handleStep } = props;
    const classes = useStyles();
    const [termCheck, setTermCheck] = useState(false);
    const [data, setFormData] = useState({
      state: null,
      landlord: null,
      apartment: null,
      policy: null,
      paymentAgreement: null,
      agreePayDate: null,
      claimType: null,
      depositAmount: null,
      rentDate: null,
      lateFilingExplanation: null,
      leaseReason: null,
      contactName: null,
      contactEmail: null,
      contactPhone: null,
      contactTitle: null,
      leaseFile: null,
      ledgerFile: null,
      payee: null,
      receiptEmail: null,
      address1: null,
      address2: null,
      currentCity: null,
      currentState: null,
      currentZipCode: null,
      vacantCheck: null,
      evictionCheck: null
    });

    const [disable, setDisable] = useState(true);

    useEffect(() => {
      const landlordObj = formData.landlordArray.filter(item => item.Id === formData.data.landlord);
      const apartmentObj = formData.apartmentArray.filter(item => item.Id === formData.data.apartment);
      const policyObj = formData.policyArray.filter(item => item.Id === formData.data.policy);

      setFormData({
        state: formData.data.state,
        landlord: landlordObj[0].Name,
        apartment: apartmentObj[0].Name,
        policy: policyObj[0].Rider_ID__c,
        paymentAgreement: formData.data.paymentAgreement,
        agreePayDate: formData.data.agreePayDate,
        depositAmount: formData.data.depositAmount,
        rentDate: formData.data.rentDate,
        lateFilingExplanation: formData.data.lateFilingExplanation,
        leaseReason: formData.data.leaseReason,
        contactName: formData.data.contactName,
        contactEmail: formData.data.contactEmail,
        contactPhone: formData.data.contactPhone,
        contactTitle: formData.data.contactTitle,
        leaseFile: formData.data.leaseFile.path,
        ledgerFile: formData.data.ledgerFile.path,
        otherFile: formData.data.otherFile ? formData.data.otherFile.path : '',
        payee: formData.data.payee,
        receiptEmail: formData.data.receiptEmail,
        address1: formData.data.address1,
        address2: formData.data.address2,
        currentCity: formData.data.currentCity,
        currentState: formData.data.currentState,
        currentZipCode: formData.data.currentZipCode,
        claimType: formData.data.claimType,
        evictionDate: formData.data.evictionDate,
        keyCheck: formData.data.keyCheck,
        vacantCheck: formData.data.vacantCheck,
        evictionCheck: formData.data.evictionCheck
      });
      setDisable(false);
    }, [formData])

    const [open, setOpen] = useState(false);

    const handleOk = () => {
        setOpen(false);
        actions.createClaimAction({
          securityDeposit: formData.data.depositAmount,
          depositAmount: formData.data.depositAmount,
          name: formData.data.contactName,
          email: formData.data.contactEmail,
          title: formData.data.contactTitle,
          phoneNumber: formData.data.contactPhone,
          defaultDate: formData.data.rentDate,
          lateFilingExplanation: formData.data.lateFilingExplanation,
          relatedExpense: formData.data.relatedExpense,
          claimType: formData.data.claimType,
          agreedPaymentDate: formData.data.agreePayDate,
          paymentAgreementStatus: formData.data.paymentAgreement,
          ledgerFile: formData.data.ledgerFile[0],
          leaseFile: formData.data.leaseFile[0],
          otherFiles: formData.data.otherFiles,
          checkName: formData.data.payee,
          checkEmail: formData.data.receiptEmail,
          checkAddress1: formData.data.address1,
          checkAddress2: formData.data.checkAddress2,
          checkCity: formData.data.currentCity,
          checkZipcode: formData.data.currentZipCode,
          riderId: formData.data.policy,
          leaseTermIscorrect: formData.data.isCorrectTerm,
          keysReturned: formData.data.keyCheck,
          evictionFiledStatus: formData.data.evictionCheck,
          evictionFilingDate: formData.data.evictionDate,
          occupiedStatus: formData.data.vacantCheck,
        }),
        handleNext();
    }

  return (
    <Fragment>
      <Grid container justifyContent="space-between">
        <Grid item md={6} xs={12}>
          <Divider sx={{mt:4, px: 2}}>
            <IconButton onClick={() => handleStep(0)}>
              <EditIcon color="primary" />
            </IconButton>
          </Divider>
          <Grid container justifyContent='space-around' sx={{ my:2 }}>
              <Grid item xs={5} sx={{mb:1}}>
                  <Typography variant="subtitle1" color="primary">Landlord Name</Typography>
                  <Typography variant="body1">{data.landlord}</Typography>
              </Grid>
              <Grid item xs={5} sx={{mb:1}}>
                  <Typography variant="subtitle1" color="primary">Community Name</Typography>
                  <Typography variant="body1">{data.apartment}</Typography>
              </Grid>
              <Grid item xs={5} sx={{mb:1}}>
                  <Typography variant="subtitle1" color="primary">Policy Reference</Typography>
                  <Typography variant="body1">{data.policy}</Typography>
              </Grid>
              <Grid item xs={5} sx={{mb:1}}>
                  <Typography variant="subtitle1" color="primary">TenancyTerm Correct</Typography>
                  <Typography variant="body1">{formData.data.isCorrectTerm}</Typography>
              </Grid>
          </Grid>
        </Grid>
        <Grid item md={6} xs={12}>
            <Divider sx={{mt:4, px:2}}>
              <IconButton onClick={() => handleStep(1)}>
                <EditIcon color="primary" />
              </IconButton>
            </Divider>
            <Grid container justifyContent='space-around' sx={{ my:2 }}>
                <Grid item xs={5} sx={{mb:1}}>
                    <Typography variant="subtitle1" color="primary">Payment Agreement Status</Typography>
                    <Typography variant="body1">{data.paymentAgreement}</Typography>
                </Grid>
                {data.agreePayDate && 
                  <Grid item xs={5} sx={{mb:1}}>
                      <Typography variant="subtitle1" color="primary">Payment Agreement Date</Typography>
                      <Typography variant="body1">{data.agreePayDate}</Typography>
                  </Grid>
                }
                <Grid item xs={5} sx={{mb:1}}>
                    <Typography variant="subtitle1" color="primary">Security Deposit Amount on Hand</Typography>
                    <Typography variant="body1">{data.depositAmount}</Typography>
                </Grid>
                <Grid item xs={5} sx={{mb:1}}>
                    <Typography variant="subtitle1" color="primary">Claim Type</Typography>
                    <Typography variant="body1">{data.claimType}</Typography>
                </Grid>
            </Grid>
        </Grid>
      </Grid>
      <Grid container justifyContent="space-between">
        <Grid item xs={12} md={6}>
          <Divider sx={{px:2}}>
            <IconButton onClick={() => handleStep(2)}>
              <EditIcon color="primary" />
            </IconButton>
          </Divider>
          <Grid container justifyContent='space-around' sx={{ mt:2 }}>
              <Grid item xs={5} sx={{mb:1}}>
                  <Typography variant="subtitle1" color="primary">Date of Loss</Typography>
                  <Typography variant="body1">{data.rentDate}</Typography>
              </Grid>
              {data.evictionCheck === 'Yes' &&
                <Grid item xs={5} sx={{mb:1}}>
                    <Typography variant="subtitle1" color="primary">Date you filed for eviction</Typography>
                    <Typography variant="body1">{data.evictionDate}</Typography>
                </Grid>
              }
              {data.lateFiling && 
                <Grid item xs={11} sx={{mb:1}}>
                    <Typography variant="subtitle1" color="primary">Explanation for the reason for late filing</Typography>
                    <Typography variant="body1">{data.lateFilingExplanation}</Typography>
                </Grid>
              }
              <Grid item xs={5} sx={{mb:1}}>
                  <Typography variant="subtitle1" color="primary">Has the tenant left the unit?</Typography>
                  <Typography variant="body1">{data.vacantCheck}</Typography>
              </Grid>
              {data.vacantCheck === 'Yes' &&
                <Grid item xs={5} sx={{mb:1}}>
                    <Typography variant="subtitle1" color="primary">Have the keys been returned?</Typography>
                    <Typography variant="body1">{data.keyCheck}</Typography>
                </Grid>
              } 
              <Grid item xs={5} sx={{mb:1}}>
                  <Typography variant="subtitle1" color="primary">Have you filed for eviction?</Typography>
                  <Typography variant="body1">{data.evictionCheck}</Typography>
              </Grid>
              <Grid item xs={5}></Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={6}>
          <Divider sx={{px:2}}>
            <IconButton onClick={() => handleStep(3)}>
              <EditIcon color="primary" />
            </IconButton>
          </Divider>
          <Grid container justifyContent='space-around' sx={{ my:2 }}>
              <Grid item xs={5} sx={{mb:1}}>
                  <Typography variant="subtitle1" color="primary">Contact Name</Typography>
                  <Typography variant="body1">{data.contactName}</Typography>
              </Grid>
              <Grid item xs={5} sx={{mb:1}}>
                  <Typography variant="subtitle1" color="primary">Contact Title</Typography>
                  <Typography variant="body1">{data.contactTitle}</Typography>
              </Grid>
              <Grid item xs={5} sx={{mb:1}}>
                  <Typography variant="subtitle1" color="primary">Contact Email</Typography>
                  <Typography variant="body1">{data.contactEmail}</Typography>
              </Grid>
              <Grid item xs={5} sx={{mb:1}}>
                  <Typography variant="subtitle1" color="primary">Contact Phone Number</Typography>
                  <Typography variant="body1">{data.contactPhone}</Typography>
              </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container justifyContent="space-between">
          <Grid item xs={12} md={6}>
              <Divider sx={{px:2}}>
                <IconButton onClick={() => handleStep(4)}>
                  <EditIcon color="primary" />
                </IconButton>
              </Divider>
              <Grid container justifyContent='space-around' sx={{ my:2 }}>
                  <Grid item xs={11} sx={{mb:1}}>
                      <Typography variant="subtitle1" color="primary">Tenancy Agreement File</Typography>
                      <Typography variant="body1">{formData.data.leaseFile[0].path}</Typography>
                  </Grid>
                  <Grid item xs={11} sx={{mb:1}}>
                      <Typography variant="subtitle1" color="primary">Detailed Resident Ledger</Typography>
                      <Typography variant="body1">{formData.data.ledgerFile[0].path}</Typography>
                  </Grid>
                  {formData.data.otherFiles && 
                    formData.data.otherFiles.map(file => 
                      <Grid item xs={11} sx={{mb:1}}>
                          <Typography variant="subtitle1" color="primary">Other File</Typography>
                          <Typography variant="body1">{file.path}</Typography>
                      </Grid>  
                    )
                  }
              </Grid>
          </Grid>
          <Grid item xs={12} md={6}>
                <Divider sx={{px:2}}>
                  <IconButton onClick={() => handleStep(5)}>
                    <EditIcon color="primary" />
                  </IconButton>
                </Divider>
                <Grid container justifyContent='space-around' sx={{ my:2 }}>
                    <Grid item xs={5} sx={{mb:1}}>
                        <Typography variant="subtitle1" color="primary">Check Payee</Typography>
                        <Typography variant="body1">{data.payee}</Typography>
                    </Grid>
                    <Grid item xs={5} sx={{mb:1}}>
                        <Typography variant="subtitle1" color="primary">Email for receipt of eCheck</Typography>
                        <Typography variant="body1">{data.receiptEmail}</Typography>
                    </Grid>
                    <Grid item xs={5} sx={{mb:1}}>
                        <Typography variant="subtitle1" color="primary">Address1</Typography>
                        <Typography variant="body1">{data.address1}</Typography>
                    </Grid>
                    <Grid item xs={5} sx={{mb:1}}>
                        <Typography variant="subtitle1" color="primary">Address2</Typography>
                        <Typography variant="body1">{data.address2}</Typography>
                    </Grid>
                    <Grid item xs={5} sx={{mb:1}}>
                        <Typography variant="subtitle1" color="primary">City</Typography>
                        <Typography variant="body1">{data.currentCity}</Typography>
                    </Grid>
                    <Grid item xs={5} sx={{mb:1}}>
                        <Typography variant="subtitle1" color="primary">ZipCode</Typography>
                        <Typography variant="body1">{data.currentZipCode}</Typography>
                    </Grid>
                </Grid>
          </Grid>
      </Grid>    
      <Divider sx={{mt:1}}>
            <Grid container justifyContent='center' wrap="nowrap" alignItems="flex-start">
                <Checkbox onChange={(e) => setTermCheck(e.target.checked)} checked={termCheck} />
                <Link href="https://leapguaranty.co.uk/terms-and-conditions/" target="_blank" color="primary" sx={{mt:1}}>
                    <Typography color="primary" variant="subtitle1" align="center">     
                    Agree with Terms & Condition
                    </Typography>
                </Link>
            </Grid>
        </Divider>
        <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', py: 2 }}>
                <Button
                  onClick={handleBack}
                  sx={{ mr: 1 }}
                  variant="contained"
                >
                Back
                </Button>

            <Button 
              onClick={() => setOpen(true)} 
              variant="contained" 
              disabled={!termCheck}
            >
                <Typography variant='body1' >
                    Next
                </Typography>
            </Button>
        </Box>
        <ConfirmDialog open={open} handleClose={() => setOpen(false)} handleOk={handleOk} />
    </Fragment>
  );
}

const mapStateToProps = (state) => {
    return {
        formData: state.formData
    };
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      actions: bindActionCreators({ 
            createClaimAction, 
        }, dispatch),
    };
  };
  
export default connect(mapStateToProps, mapDispatchToProps)(Form7);
